<template>
  <div>
    <a-card :bordered="false" :bodyStyle="tstyle">
      <div class="table-page-search-wrapper" v-if="hasPerm('vIhZyjstj:page')">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="住院号">
                <a-input v-model="queryParam.paid" allow-clear placeholder="请输入住院号"/>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="姓名">
                <a-input v-model="queryParam.paname" allow-clear placeholder="请输入姓名"/>
              </a-form-item>
            </a-col>
            <template v-if="advanced">
              <a-col :md="8" :sm="24">
                <a-form-item label="性别">
                  <a-input v-model="queryParam.sex" allow-clear placeholder="请输入性别"/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="出生日期">
                  <a-date-picker style="width: 100%" placeholder="请选择出生日期" v-model="queryParam.birthdayDate" @change="onChangebirthday"/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="收款人">
                  <a-input v-model="queryParam.sheetpsid" allow-clear placeholder="请输入收款人"/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="收款日期">
                  <a-date-picker style="width: 100%" placeholder="请选择收款日期" v-model="queryParam.sheetpsdateDate" @change="onChangesheetpsdate"/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="单据状态">
                  <a-input v-model="queryParam.sheetstatus" allow-clear placeholder="请输入单据状态"/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="退费单据号">
                  <a-input v-model="queryParam.returnchId" allow-clear placeholder="请输入退费单据号"/>
                </a-form-item>
              </a-col>
            </template>
            <a-col :md="8" :sm="24" >
              <span class="table-page-search-submitButtons">
                <a-button type="primary" @click="$refs.table.refresh(true)" >查询</a-button>
                <a-button style="margin-left: 8px" @click="() => queryParam = {}">重置</a-button>
                <a @click="toggleAdvanced" style="margin-left: 8px">
                  {{ advanced ? '收起' : '展开' }}
                  <a-icon :type="advanced ? 'up' : 'down'"/>
                </a>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
    </a-card>
    <a-card :bordered="false">
      <s-table
        ref="table"
        :columns="columns"
        :data="loadData"
        :alert="options.alert"
        :rowKey="(record) => record.chid"
        :rowSelection="options.rowSelection"
      >
        <!-- <template class="table-operator" slot="operator" v-if="hasPerm('vIhZyjstj:add')" >
          <a-button type="primary" v-if="hasPerm('vIhZyjstj:add')" icon="plus" @click="$refs.addForm.add()">新增住院结算统计</a-button>
          <a-button type="danger" :disabled="selectedRowKeys.length < 1" v-if="hasPerm('vIhZyjstj:delete')" @click="batchDelete"><a-icon type="delete"/>批量删除</a-button>
          <x-down
            v-if="hasPerm('vIhZyjstj:export')"
            ref="batchExport"
            @batchExport="batchExport"
          />
        </template>
        <span slot="action" slot-scope="text, record">
          <a v-if="hasPerm('vIhZyjstj:edit')" @click="$refs.editForm.edit(record)">编辑</a>
          <a-divider type="vertical" v-if="hasPerm('vIhZyjstj:edit') & hasPerm('vIhZyjstj:delete')"/>
          <a-popconfirm v-if="hasPerm('vIhZyjstj:delete')" placement="topRight" title="确认删除？" @confirm="() => singleDelete(record)">
            <a>删除</a>
          </a-popconfirm>
        </span> -->
      </s-table>
      <!-- <add-form ref="addForm" @ok="handleOk" /> -->
      <!-- <edit-form ref="editForm" @ok="handleOk" /> -->
    </a-card>
  </div>
</template>
<script>
  import { STable, XDown } from '@/components'
  import moment from 'moment'
import { vIhZyjstjPage, vIhZyjstjDelete, vIhZyjstjExport } from '@/api/modular/interhospital/leavehospital/leavehospitalManage'
  // import addForm from './addForm.vue'
  // import editForm from './editForm.vue'
  export default {
    components: {
      STable,
      // addForm,
      // editForm,
      XDown
    },
    data () {
      return {
        // 高级搜索 展开/关闭
        advanced: false,
        // 查询参数
        queryParam: {},
        // 表头
        columns: [
          {
            title: '住院号',
            align: 'center',
            dataIndex: 'paid'
          },
          {
            title: '姓名',
            align: 'center',
            dataIndex: 'paname'
          },
          {
            title: '性别',
            align: 'center',
            dataIndex: 'sex'
          },
          {
            title: '出生日期',
            align: 'center',
            dataIndex: 'birthday'
          },
          {
            title: '标价金额',
            align: 'center',
            dataIndex: 'totalfee'
          },
          {
            title: '应收金额',
            align: 'center',
            dataIndex: 'oughtfee'
          },
          {
            title: '预交金金额',
            align: 'center',
            dataIndex: 'confee'
          },
          {
            title: '收款人',
            align: 'center',
            dataIndex: 'sheetpsid'
          },
          {
            title: '收款日期',
            align: 'center',
            dataIndex: 'sheetpsdate'
          },
          {
            title: '单据状态',
            align: 'center',
            dataIndex: 'sheetstatus'
          },
          {
            title: '账户',
            align: 'center',
            dataIndex: 'accpay'
          },
          {
            title: '统筹',
            align: 'center',
            dataIndex: 'fundpay'
          },
          {
            title: '微信',
            align: 'center',
            dataIndex: 'wxpay'
          },
          {
            title: '聚合支付',
            align: 'center',
            dataIndex: 'ccbpay'
          },
          {
            title: '现金',
            align: 'center',
            dataIndex: 'cashpay'
          },
          {
            title: '退费单据号',
            align: 'center',
            dataIndex: 'returnchId'
          }
        ],
        tstyle: { 'padding-bottom': '0px', 'margin-bottom': '10px' },
        // 加载数据方法 必须为 Promise 对象
        loadData: parameter => {
          return vIhZyjstjPage(Object.assign(parameter, this.switchingDate())).then((res) => {
            return res.data
          })
        },
        selectedRowKeys: [],
        selectedRows: [],
        options: {
          alert: { show: true, clear: () => { this.selectedRowKeys = [] } },
          rowSelection: {
            selectedRowKeys: this.selectedRowKeys,
            onChange: this.onSelectChange
          }
        }
      }
    },
    created () {
      if (this.hasPerm('vIhZyjstj:edit') || this.hasPerm('vIhZyjstj:delete')) {
        this.columns.push({
          title: '操作',
          width: '150px',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' }
        })
      }
    },
    methods: {
      moment,
      /**
       * 查询参数组装
       */
      switchingDate () {
        const queryParambirthday = this.queryParam.birthdayDate
        if (queryParambirthday != null) {
            this.queryParam.birthday = moment(queryParambirthday).format('YYYY-MM-DD')
            if (queryParambirthday.length < 1) {
                delete this.queryParam.birthday
            }
        }
        const queryParamsheetpsdate = this.queryParam.sheetpsdateDate
        if (queryParamsheetpsdate != null) {
            this.queryParam.sheetpsdate = moment(queryParamsheetpsdate).format('YYYY-MM-DD')
            if (queryParamsheetpsdate.length < 1) {
                delete this.queryParam.sheetpsdate
            }
        }
        const obj = JSON.parse(JSON.stringify(this.queryParam))
        return obj
      },
      /**
       * 单个删除
       */
      singleDelete (record) {
        const param = [{ 'chid': record.chid }]
        this.vIhZyjstjDelete(param)
      },
      /**
       * 批量删除
       */
      batchDelete () {
        const paramIds = this.selectedRowKeys.map((d) => {
            return { 'chid': d }
        })
        this.vIhZyjstjDelete(paramIds)
      },
      vIhZyjstjDelete (record) {
        vIhZyjstjDelete(record).then((res) => {
          if (res.success) {
            this.$message.success('删除成功')
            this.$refs.table.clearRefreshSelected()
          } else {
            this.$message.error('删除失败') // + res.message
          }
        })
      },
      toggleAdvanced () {
        this.advanced = !this.advanced
      },
      onChangebirthday(date, dateString) {
        this.birthdayDateString = dateString
      },
      onChangesheetpsdate(date, dateString) {
        this.sheetpsdateDateString = dateString
      },
      /**
       * 批量导出
       */
      batchExport () {
        const paramIds = this.selectedRowKeys.map((d) => {
            return { 'chid': d }
        })
        vIhZyjstjExport(paramIds).then((res) => {
            this.$refs.batchExport.downloadfile(res)
        })
      },
      handleOk () {
        this.$refs.table.refresh()
      },
      onSelectChange (selectedRowKeys, selectedRows) {
        this.selectedRowKeys = selectedRowKeys
        this.selectedRows = selectedRows
      }
    }
  }
</script>
<style lang="less">
  .table-operator {
    margin-bottom: 18px;
  }
  button {
    margin-right: 8px;
  }
</style>
